import React, { useState } from "react";
import axios from "axios";
import { Mail, ArrowUpRight } from "lucide-react";
import { useLang } from "../LanguageContext";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function NewsletterForm() {
  const { t } = useLang();
  const [email, setEmail] = useState("");
  const [result, setResult] = useState(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const res = await axios.post(`${API}/newsletter`, { email });
      setResult(res.data);
    } catch {
      setResult({ error: true });
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="newsletter-block" className="w-full max-w-md">
      <p className="qw-overline mb-3 flex items-center gap-2">
        <Mail size={12} strokeWidth={1.2} /> {t.newsletter.title}
      </p>
      <p className="text-sm text-muted-foreground mb-5">{t.newsletter.subtitle}</p>
      {result?.code ? (
        <div data-testid="newsletter-success" className="border border-primary p-5">
          <p className="text-xs text-muted-foreground mb-2">
            {result.already_subscribed ? t.newsletter.already : t.newsletter.success}
          </p>
          <p className="font-serif text-2xl text-primary tracking-wider">{result.code}</p>
        </div>
      ) : (
        <form onSubmit={submit} className="flex items-end gap-3">
          <input
            data-testid="newsletter-email-input"
            required
            type="email"
            placeholder={t.newsletter.placeholder}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="qw-input flex-1"
          />
          <button
            disabled={busy}
            data-testid="newsletter-submit-btn"
            type="submit"
            className="qw-btn qw-btn-primary disabled:opacity-60"
          >
            {t.newsletter.subscribe} <ArrowUpRight size={14} strokeWidth={1.2} />
          </button>
        </form>
      )}
    </div>
  );
}
